import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  image?: IGatsbyImageDataObject
}
function ProcreateIntroPart3(props: Props) {
  const { image } = props
  return (
    <div className=''>
      <div className='w-full px-4 py-8 text-center text-white bg-rusted-900 xl:py-16'>
        <h2 className='relative flex flex-col text-[2.9rem] leading-[2.8rem] font-sentinel__SemiBoldItal md:section-h2 z-3 md:max-w-[480px] mx-auto xl:max-w-none'>
          Making patterns is supposed to be fun.
        </h2>
      </div>
      <BackgroundImageV5
        bgImageClasses='bgImageClasses hidden relative h-[300px] md:block md:absolute md:h-full'
        innerDivClasses='et-grid-basic md:min-h-0 lg:min-h-[auto]'
        gatsbyDataImg={image?.gatsbyImageData}
        showBlurImage={true}>
        <div className='relative col-span-2 col-start-2 pb-12 z-3 md:col-start-2 md:col-span-7 md:py-12 lg:col-start-3 lg:col-span-6 lg:py-20 xl:col-start-3 xl:col-span-5 xxl:col-start-2 xxl:col-span-6 xxl:py-36 '>
          <h2 className='mt-8 text-2xl font-sentinel__MediumItal text-rusted-900 md:mt-0 xxl:text-4xl'>
            There <span className='font-bold'>had</span> to be a better, quicker and easier way. But not just for the making or the testing.
          </h2>
          <p className='pt-4 text-4xl pb-28 text-rusted-400 '>
            For the <span className='text-5xl font-sentinel__SemiBoldItal'>all-of-it</span>.
          </p>
          <p className='text-4xl font-sentinel__SemiBoldItal text-rusted-900'>
            so we made one.
            <span className='block font-sans text-xl font-normal'>(the all-of-it kind)</span>
          </p>
        </div>
      </BackgroundImageV5>

    </div>
  )
}

export default ProcreateIntroPart3
